import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'say-input-telephone',
  templateUrl: './input-telephone.component.html',
  styleUrls: ['./input-telephone.component.scss']
})
export class InputTelephoneComponent implements OnInit {

  /** Toggles error state */
  @Input() hasError: boolean = false;
  /** Error message to be displayed */
  @Input() errorMessage: string = 'Placeholder Error Message';
  /** Label Text for Input */
  @Input() title: string = 'Phone Number';
  /** Phone number to be trimmed and emitted */
  @Input() phoneNumber: string;
  /** ID used for html attributes. Computed from title */
  public id: string;

  @Output() phoneChanged: EventEmitter<string> = new EventEmitter();

  constructor() { }

  ngOnInit() {
    this.id = this.title.replace(/ /g, '-').replace(/:/g, '').toLowerCase();
  }

  /** Trims phone number that is formatted by directive and emits it to component that uses this template */
  trimPhone() {
    // assumes that phone number is in the (123) 456-7890 format
    if (this.phoneNumber.length <= 14) {

      // remove parenthesis, hyphens, and space.
      this.phoneNumber = this.phoneNumber.replace(/[^0-9]/g, '');

      // emit the change to the phone number
      this.phoneChanged.emit(this.phoneNumber);
    }
  }
}
